module.exports = __webpack_public_path__ + "img/advantage_two.60ab72a3.png";